import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { FunctionComponent, Suspense } from 'react';
import OrgTree, { ProcessedOrgTree } from '../OrgTree';

const CreateProductCustomerRestrictionsModal: FunctionComponent<
  ModalProps<{ onConfirmCallback: (orgTree: ProcessedOrgTree[]) => Promise<void>; orgTree: ProcessedOrgTree[] }>
> = props => {
  const CreateProductCustomerRestrictions = () => {
    const confirmCallback = props.props?.onConfirmCallback;
    const orgTree = props.props?.orgTree;
    if (!(confirmCallback && orgTree)) throw new Error('Missing props');

    const onSubmit = async () => {
      await confirmCallback(orgTree);

      props.close();
    };

    return (
      <Card className="w-full p-8 space-y-3">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Customer Restrictions</h1>
        </Modal.Controls>

        <div className="space-y-1">
          <p>Please select which MSPs and customers should be able to see this product.</p>
          <OrgTree data={orgTree} />
        </div>

        <div className="flex gap-2 justify-between">
          <Button onClick={props.close}>Cancel</Button>
          <Button type="button" variant={ButtonVariant.Primary} loading={false} onClick={onSubmit}>
            Ok
          </Button>
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <CreateProductCustomerRestrictions />
      </Suspense>
    </Modal>
  );
};

export default CreateProductCustomerRestrictionsModal;
